var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "file-upload" },
    [
      _vm._m(0),
      _c("div", { staticClass: "upload-area" }, [
        _c("div", { staticClass: "upload-input-box" }, [
          _c("div", { staticClass: "upload-input" }, [
            _c("div", { staticClass: "editable-container" }, [
              _c("div", {
                ref: "editableDiv",
                staticClass: "editable-div",
                attrs: { contenteditable: "true" },
                on: {
                  input: _vm.handleInput,
                  paste: _vm.handlePaste,
                  keydown: _vm.handleKeyDown,
                },
              }),
              !_vm.link
                ? _c("div", { staticClass: "placeholder" }, [
                    _vm._v(" 请输入链接或拖动文件到这里上传 "),
                  ])
                : _vm._e(),
            ]),
          ]),
          _c("div", { staticClass: "upload-options" }, [
            _c("label", { attrs: { for: "file-upload-input" } }, [
              _c(
                "div",
                { staticClass: "upload-icon-warpper" },
                [
                  _c(
                    "el-tooltip",
                    {
                      attrs: {
                        effect: "dark",
                        content: "上传文件",
                        placement: "top",
                        "popper-class": "custom-zyq-prpper",
                      },
                    },
                    [
                      _c("svg-icon", {
                        staticClass: "icon",
                        attrs: { "icon-class": "file-upload" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("input", {
              staticStyle: { display: "none" },
              attrs: { id: "file-upload-input", type: "file" },
              on: { change: _vm.handleFileUpload },
            }),
            _c(
              "div",
              { staticClass: "send-icon-warpper" },
              [
                !_vm.link
                  ? _c(
                      "div",
                      {
                        staticClass: "disable-cursor",
                        attrs: {
                          effect: "dark",
                          content: "发送链接",
                          placement: "top",
                          "popper-class": "custom-zyq-prpper",
                        },
                      },
                      [
                        _c("svg-icon", {
                          staticClass: "icon disable-click",
                          attrs: { "icon-class": "send" },
                          on: { click: _vm.handleSend },
                        }),
                      ],
                      1
                    )
                  : _c(
                      "el-tooltip",
                      {
                        attrs: {
                          effect: "dark",
                          content: "发送链接",
                          placement: "top",
                          "popper-class": "custom-zyq-prpper",
                        },
                      },
                      [
                        _c("svg-icon", {
                          staticClass: "icon",
                          attrs: {
                            "icon-class": _vm.link ? "send_active" : "send",
                          },
                          on: { click: _vm.handleSend },
                        }),
                      ],
                      1
                    ),
              ],
              1
            ),
          ]),
          _vm.isShowBatchExtractTip
            ? _c("div", { staticClass: "batch-extract-tip" }, [
                _c("span", [
                  _vm._v(
                    "使用【shift + 回车】换行，输入更多链接可批量提取内容"
                  ),
                ]),
                _c("span", [_vm._v("|")]),
                _c("i", {
                  staticClass: "el-icon-close",
                  staticStyle: { "margin-top": "2px" },
                  on: {
                    click: function ($event) {
                      _vm.isShowBatchExtractTip = false
                    },
                  },
                }),
              ])
            : _vm._e(),
        ]),
        _c("div", { staticClass: "upload-tip" }, [
          _c(
            "div",
            { staticClass: "tip-item" },
            [
              _c("svg-icon", {
                staticClass: "tip-item-icon",
                attrs: { "icon-class": "_link" },
              }),
              _c("span", [_vm._v("链接支持：")]),
              _vm._l(_vm.links, function (item, index) {
                return _c(
                  "div",
                  {
                    key: item.name,
                    staticStyle: { display: "flex", "align-items": "center" },
                    on: { click: _vm.handlePointClick },
                  },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "tip-item-name",
                        attrs: { href: item.url, target: "_blank" },
                      },
                      [_vm._v(_vm._s(item.name) + " ")]
                    ),
                    index !== _vm.links.length - 1
                      ? _c("div", {
                          staticStyle: {
                            width: "1px",
                            height: "13px",
                            "background-color": "#808080",
                            margin: "0 5px",
                          },
                        })
                      : _vm._e(),
                  ]
                )
              }),
              _c(
                "el-tooltip",
                {
                  attrs: {
                    effect: "dark",
                    placement: "bottom",
                    "popper-class": "custom-zyq-prpper",
                  },
                },
                [
                  _c("div", { attrs: { slot: "content" }, slot: "content" }, [
                    _c(
                      "div",
                      { staticClass: "tool-tip" },
                      _vm._l(_vm.tooltipTips, function (tip) {
                        return _c(
                          "div",
                          { key: tip.icon, staticClass: "tool-tip-item" },
                          [
                            _c("svg-icon", {
                              staticClass: "tool-tip-item-icon",
                              attrs: { "icon-class": tip.icon },
                            }),
                            _c("p", [_vm._v(_vm._s(tip.content))]),
                          ],
                          1
                        )
                      }),
                      0
                    ),
                  ]),
                  _c("svg-icon", {
                    staticClass: "question",
                    attrs: { "icon-class": "q" },
                  }),
                ],
                1
              ),
            ],
            2
          ),
        ]),
      ]),
      _c("CustomDialog", {
        attrs: {
          visiable: _vm.showCustomDialog,
          "is-more": true,
          content: "最多同时上传5个文件，请重新选择",
        },
        on: {
          "update:visiable": function ($event) {
            _vm.showCustomDialog = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "file-title" }, [
      _c("img", {
        staticClass: "title-icon",
        attrs: { src: require("@/assets/image/extract-title.png"), alt: "" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }